module.exports = __webpack_public_path__ + "static/media/mbennasar2.4e8677d3.jpg";